module.exports = {"pathContext":{"slug":"/it/tutoring/","langKey":"it"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/it-tutoring.json
// module id = 1599
// module chunks = 249842937396398